import { Helmet } from 'react-helmet-async';
import { LegalPageLayout } from '../components/legal/LegalPageLayout';
import { HighlightBox } from '../components/legal/HighlightBox';

export const TermsPage = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service — Solo Sense</title>
        <meta name="description" content="Terms of Service for Solo Sense, the spatial transcription app for Apple Vision Pro. Read about usage terms, responsibilities, and limitations." />
        <link rel="canonical" href="https://solosense.ai/terms" />
      </Helmet>
    <LegalPageLayout
      title="Terms of Service"
      meta="Effective Date: January 04, 2026"
    >
      <h2>1. Acceptance</h2>
      <p>By using SOLO SENSE, you agree to these Terms.</p>

      <h2>2. Intended Use</h2>
      <p>SOLO SENSE is provided as an accessibility and communication aid. It is not a medical, legal, or surveillance tool.</p>

      <h2>3. User Responsibilities</h2>
      <p>Users are responsible for:</p>
      <ul>
        <li>Obtaining permission where required</li>
        <li>Complying with local laws and venue policies</li>
        <li>Using the app ethically and respectfully</li>
      </ul>

      <h2>4. No Guarantees</h2>
      <p>Accuracy of captions or translations may vary based on environment and audio quality.</p>

      <h2>5. Limitation of Liability</h2>
      <p>SOLO SENSE is provided "as is." We are not liable for indirect or consequential damages.</p>

      <h2>6. Termination</h2>
      <p>We may suspend access for misuse or legal compliance.</p>

      <HighlightBox title="Government & Public Sector Readiness">
        <p>SOLO SENSE:</p>
        <ul>
          <li>Does not retain user communications</li>
          <li>Does not conduct surveillance</li>
          <li>Supports accessibility mandates (ADA-aligned use)</li>
          <li>Can be deployed without centralized data storage</li>
          <li>Supports privacy-by-design principles</li>
        </ul>
        <p>Available for pilot programs, accessibility initiatives, and assistive technology deployments.</p>
      </HighlightBox>

      <h2>Contact</h2>
      <p>
        <strong>SOLO SENSE</strong><br />
        Email: <a href="mailto:privacy@solosense.ai">privacy@solosense.ai</a><br />
        Website: <a href="https://www.solosense.ai">www.solosense.ai</a>
      </p>
    </LegalPageLayout>
    </>
  );
};
